import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    doFakeAuth,
    switchDumpVarsState,
    switchShowCaptchState
} from '../../actions/development-tools';
import {
    DevelopmentTools,
    DevelopmentToolsProps
} from '../../components/DevelopmentTools/DevelopmentTools';
import { selectFakeAuthParams } from '../../selectors/dev';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<DevelopmentToolsProps>;

type DispatchProps = TDispatchProps<DevelopmentToolsProps>;

const mapStateToProps = (state: State): StateProps => {
    return {
        devInfo: state.devInfo,
        fakeAuth: selectFakeAuthParams(state)
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        switchShowCaptchaState: () => dispatch(switchShowCaptchState()),
        switchDumpVarsState: () => dispatch(switchDumpVarsState()),
        doFakeAuth: (login: string) => dispatch(doFakeAuth(login))
    };
};

export const DevelopmentToolsContainer = connect<StateProps, DispatchProps, {}>(
    mapStateToProps,
    mapDispatchToProps
)(DevelopmentTools);
